import React from 'react';
import PropTypes from 'prop-types';
import Styles from './style.css';

function Dot (props) {
    return (
        <span className={Styles.dot} style={{
            backgroundColor: props.selected ? 'var(--first-color)' : '#efefef',
            transitionDuration: '300ms'
        }} />
    )
}

export default function IndicatorDots (props) {

    const wrapperStyle = {
        position: 'absolute',
        width: '100%',
        zIndex: '100',
        textAlign: 'center'
    };

    if (props.total < 2) {
        // Hide dots when there is only one dot.
        return <div className={Styles.wrapper} style={wrapperStyle} />
    } else {
        return (
            <div className={Styles.wrapper}  style={wrapperStyle}>{
                Array.apply(null, Array(props.total)).map((x, i) => {
                    return <Dot key={i} selected={props.index === i} />
                })
            }</div>
        )
    }
}

IndicatorDots.propTypes = {
    index: PropTypes.number.isRequired,
    total: PropTypes.number.isRequired
}


// WEBPACK FOOTER //
// ./src/components/carousel-indicators/component.js